import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './PercentBar.scss';

class PercentBar extends Component {
  static propTypes = {
    percentage: PropTypes.number,
    className: PropTypes.string
  };

  render() {
    const outerStyle = {
      width: this.props.percentage + '%',
      backgroundColor: this.props.className === 'bottom' ? '#f0ad4e' : '#a6d452'
    };
    return (
      <div className="percent__bar">
        <div className="percent__bar--inner" />
        <div className="percent__bar--outer" style={outerStyle} />
      </div>
    );
  }
}

export default PercentBar;
